/*
	CHIPS_KEYBOARD_NAV v0.001
	Last update 9/30/2021
*/
const CHIPS_KEYBOARD_NAV = {
	constructor() {},
	init() {
		let appScope = this;
		this.modalopen = false;

		// rebind
		this.jsEvts = this.bindEvents();
	},
	bindEvents() {
		let appScope = this;

		document.addEventListener("keyup", function (e) {
			if (e.key === "Escape" || e.keyCode === 27) {
				// appScope.closeModal();

				if (document.querySelector(".modal-return")) {
					document.querySelector(".modal-return a").click();
				}
			}
		});

		$(document).on("focusin", function (event) {
			var $target = $(event.target);

			if (
				$(".modal-contents").hasClass("modal-contents") &&
				$("body").hasClass("has-modal")
			) {
				if (!$target.closest(".page-modal-wrap").length) {
					console.log("You focused outside of modal contents!");
					$(".modal-return a").focus();
				}
			} else if (appScope.modalopen) {
				// Keep focus inside of menu
				if (!$target.closest("header").length) {
					console.log("You focused outside of nav!");
					// $(".menu-close-toggle").focus();
				}
			} else if (appScope.searchopen) {
				if (!$target.closest("header").length) {
					console.log("You focused outside of nav!");
					// $(".menu-search-toggle").focus();
				}
			}
		});
	},
};

export default CHIPS_KEYBOARD_NAV;
